import React, { Component } from 'react'
import { connect } from 'react-redux'
class FourOhFour extends Component {
  componentDidMount () {
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: '404'
    })
  }
  render () {
    return (
      <div className='content-wrapper'>
        <div className='fourohfour-wrapper'>
          <div className='fourohfour-text-wrapper'>
            <i className='fa fa-exclamation' />
            <h3 className='text-center'>404 NOT FOUND</h3>
          </div>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
FourOhFour = connect(state => state.siteReducer)(FourOhFour)
export default FourOhFour



// WEBPACK FOOTER //
// ./src/views/core/404.js